module.exports = __webpack_public_path__ + "img/tr_p_companies_faq.9fa2e82c.jpg";